import { Box, Breadcrumbs, Link } from '@mui/material';
import React from 'react';
import { useNavigate } from 'react-router-dom';

interface IAppBreadcrumbItem {
	label?: string | null;
	location?: string;
}
type CAppBreadcrumbsProps = {
	items: IAppBreadcrumbItem[];
};

const CAppBreadcrumbs = (props: CAppBreadcrumbsProps) => {
	const { items } = props;

	const navigate = useNavigate();

	return (
		<Breadcrumbs separator=">" color="primary" sx={{ fontSize: '0.85rem', fontWeight: 400 }}>
			{items.map((item, key) => (
				<Box key={key}>
					{item?.location ? (
						<Link
							underline="hover"
							key={key}
							color="inherit"
							onClick={() => item.location && navigate(item.location)}
						>
							{item.label}
						</Link>
					) : (
						<Box component="span" key={key} color="inherit">
							{item.label}
						</Box>
					)}
				</Box>
			))}
		</Breadcrumbs>
	);
};

export default CAppBreadcrumbs;
